import { useInjectReducer, useInjectSaga } from "redux-injectors";
import saga from "./saga";
import { reducer } from "./slice";

export default function AdminDashboardInjectors() {
  useInjectReducer({ key: "adminDashboard", reducer });
  useInjectSaga({ key: "adminDashboard", saga });
  return null;
}
